export const analyzeEndpoint = '/api/v1/md/analyze';
export const liquidityEndpoint = '/api/v1/liquidity/analyze';
